export default {
  payChannel: 'Moyens de paiement',
  cashierDesk: 'Caisse',
  billAddress: 'Adresse de facturation',
  paySuccess: 'Paiement réussi',
  payError: 'Échec du paiement',
  harvestAddress: 'Adresse de livraison',
  orderAddress: 'Adresse de facturation',
  selectAddress: 'Sélectionner une adresse de livraison',
  addOrderAddress: "Veuillez d'abord ajouter l'adresse de facturation",
  addSelectAddress: 'Veuillez sélectionner une adresse de livraison',
  noAddress: 'Aucune adresse de livraison disponible',
  holder: {
    inputPayPwd: 'Veuillez définir le mot de passe de paiement',
    returnExchange: 'Paiement non effectué. Impossible de traiter la demande de retour/échange.',
  },
  transferTitle: 'Virement bancaire',
  changeAddress: "Changer l'adresse",
  editText: 'Modifier',
  payWithbalance: 'Payer avec le solde acbuy',
  bankTransferRemittance: 'Virement bancaire',
  transferTips:
    '0 frais de service sur acbuy pour le virement. Plus le montant de la commande est élevé, plus les économies sont importantes !',
  pay: 'Offres de rechargement',
  plsSetPsd: 'Veuillez définir le mot de passe de paiement',
  thirdPayTips: 'Les paiements sont disponibles dans le monde entier et en plusieurs devises',
  payProcessing: 'Traitement du paiement',
  payWaitingText:
    'Veuillez patienter 1 à 2 minutes, veuillez vérifier le résultat du paiement ultérieurement',
  coinpalTips:
    'Les recharges de monnaie numérique (monnaie virtuelle) sont non remboursables et ne peuvent pas être retirées. Si vous acceptez cela, veuillez procéder à la recharge.',
}
